import { render } from "../templates/TermsOfServiceTemplate.html?vue&type=template&id=5dadc670&scoped=true&ts=true"
import script from "./TermsOfService.vue?vue&type=script&lang=ts"
export * from "./TermsOfService.vue?vue&type=script&lang=ts"

import "./TermsOfService.vue?vue&type=style&index=0&id=5dadc670&scoped=true&lang=scss"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/AKAD/Public Website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dadc670"]])

export default __exports__